export function Timer(delay, callback) {
  let timerId
  let start
  let remaining = delay

  this.pause = () => {
    clearTimeout(timerId)
    remaining -= new Date() - start
  }

  this.resume = () => {
    start = new Date()
    clearTimeout(timerId)
    timerId = setTimeout(callback, remaining)
    // console.log('resume', timerId, remaining)
  }

  this.getTimeRemaining = () => {
    return remaining
  }
}
